import { render, staticRenderFns } from "./addCoO.vue?vue&type=template&id=1f0abcaa&"
import script from "./addCoO.vue?vue&type=script&lang=js&"
export * from "./addCoO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports